export default class FormItemDateResolver
{
	//非法值
	static _invalidValues = [];
	//defaultValue
	static _defaultValue = "";
	
	static getResult_Step1(dateInput)
	{
		if(dateInput=="" || dateInput == null)
		{
			return "";
		}
		
		if(dateInput.toLowerCase() == "t" || dateInput == "0")
		{
			return FormItemDateResolver.dataStyle(new Date());
		}
		
		var length=dateInput.length;
		if(FormItemDateResolver.IsInt(dateInput))
		{
			if(dateInput.indexOf("-") != -1)
			{
				return FormItemDateResolver.convertToDateLenIs8(FormItemDateResolver.returnFormDate(dateInput));
			}
			else
			{
				if(length>8)
					return "false:格式错误";
				
			}
			switch(length)
			{
				case 1:{
					return FormItemDateResolver.convertToDateLenIs1(dateInput);
					break;
				}
				case 2:{
					return FormItemDateResolver.convertToDateLenIs2(dateInput);
					break;
				}
				case 3:{
					return FormItemDateResolver.convertToDateLenIs3(dateInput);
					break;
				}
				case 4:{
					return FormItemDateResolver.convertToDateLenIs4(dateInput);
					break;
				}
				case 5:{
					return FormItemDateResolver.convertToDateLenIs5(dateInput);
					break;
				}
				case 6:{
					return FormItemDateResolver.convertToDateLenIs6(dateInput);
					break;
				}
				case 7:{
					return FormItemDateResolver.convertToDateLenIs7(dateInput);
					break;
				}
				case 8:{
					return FormItemDateResolver.convertToDateLenIs8(dateInput);
					break;
				}
				default:{
					return "false:格式错误";
					//throw new Error("the reg is not correct");
				}
			}
		}
		else
		{
			
			return "false:格式错误";
		}
		
	}
	
	static getResult()
	{
		var dateInput = arguments[0];
		var result = FormItemDateResolver.getResult_Step1(dateInput);
		if(arguments.length>0 && arguments[1] == true)
		{
			if(result == "" || result == "1970-01-01")
			{
				return "false:不允许空值";
			}
		}
		for(var i in FormItemDateResolver._invalidValues)
		{
			let invalidValue = FormItemDateResolver._invalidValues[i];
			if(result == invalidValue)
			{
				return _defaultValue;
			}
		}
		
		return result;			
		
	}
	
	
	static getFullYear(year)
	{
		var fullYear  =  new Date().getFullYear();
		return (fullYear+"").substr(0,4-year.length)+year;
	}
	
	
	//将输入的--年份补成八位
	static returnFormDate(dateInput)
	{
		var inputArray=dateInput.split("-");
		var year;
		var month = inputArray[1];
		var day = inputArray[2];
		year = FormItemDateResolver.getFullYear(inputArray[0]);
		
		if(month.length == 1)
		{
			month = "0" + month;
		}
		if(day.length == 1)
		{
			day = "0" + day;
		}
		return year+month+day;
	}
	
	//判断字符串是否由数字组成
	static IsInt(dateInput)
	{
		var pattern =/^-?\d+$/;
		var patternDate = /^(\d{1,4})(-)?(\d{1,2})\2(\d{1,2})$/;
		var result = pattern.exec(dateInput);
		if(result == null) {
			if(patternDate.exec(dateInput)==null){
				return false;
			}
		}
		return true;
	}
	
	
	
	
	//1 to 2
	static convertToDateLenIs1(dateInput)
	{
		
		return FormItemDateResolver.convertToDateLenIs2("0"+dateInput);
	}
	
	//2 to 4
	static convertToDateLenIs2(dateInput)
	{
		var month = new Date().getMonth() + 1;
		if((month+"").length == 1)
		{
			month = "0" + month;
		}
		return FormItemDateResolver.convertToDateLenIs4(month+dateInput);		
	}
	
	//3 to 4
	static convertToDateLenIs3(dateInput)
	{
		return FormItemDateResolver.convertToDateLenIs4("0"+dateInput);
	}
	
	//4 to 8
	static convertToDateLenIs4(dateInput)
	{
		var fullYear = new Date().getFullYear();
		return FormItemDateResolver.convertToDateLenIs8(fullYear+dateInput);
	}
	
	// 5 to 8
	static convertToDateLenIs5(dateInput)
	{
		var fullYear:String = new Date().getFullYear();
		return FormItemDateResolver.convertToDateLenIs8((fullYear+"").substr(0,3)+dateInput);
		
	}
	
	// 6 to 8
	static convertToDateLenIs6(dateInput)
	{
		var fullYear = new Date().getFullYear();
		return FormItemDateResolver.convertToDateLenIs8((fullYear+"").substr(0,2)+dateInput);
		
	}
	
	//7 to 8
	static convertToDateLenIs7(dateInput)
	{
		return FormItemDateResolver.convertToDateLenIs8("0"+dateInput);
		
	}
	
	
	
	static convertToDateLenIs8(dateInput)
	{
		var month;
		var day;
		var fullYear = FormItemDateResolver.returnYears(dateInput);
		
		month=parseInt(dateInput.charAt(4)+dateInput.charAt(5));
		day=parseInt(dateInput.substr(6,7));
		
		if(month > 12)
			month = 12;
		if(month <= 0)
			month = 1;
		
		var totalDay = FormItemDateResolver.countDays(month,fullYear);
		if(day>totalDay)
		{
			day = totalDay;
		}
		if(day<=0)
		{
			day = 1;
		}
		var fullYearS = fullYear+"";
		while(fullYearS.length<4)
		{
			fullYearS = "0"+fullYearS;
		}
		if(fullYearS == "0000")
		{
			fullYearS = new Date().getFullYear();
		}
		var months = month+"";
		while(months.length<2)
		{
			months = "0"+months;
		}
		
		var days = day+"";
		while(days.length<2)
		{
			days = "0"+days;
		}
		return fullYearS+"-"+months+"-"+days;
	}
	
	//TODO format有时不是函数 则采用替代方式 理论上要在原型链上注册自定义的format函数 日期以年月日输出
	/*
	Date.prototype.Format = function (fmt) { //author: meizz 
    var o = {
        "M+": this.getMonth() + 1, //月份 
        "d+": this.getDate(), //日 
        "h+": this.getHours(), //小时 
        "m+": this.getMinutes(), //分 
        "s+": this.getSeconds(), //秒 
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度 
        "S": this.getMilliseconds() //毫秒 
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
	}
	*/
	static dataStyle(date)
	{
		if(typeof(date.format) == "function")
		{
			return date.format("yyyy-MM-dd");
		}
		else
		{
			let isoString = date.toISOString();
			return isoString.split("T")[0];
		}
	}
	
	//计算一个月的天数
	static countDays(month,year)
	{
		
		var days31=['01','03','05','07','08','10','12','1','3','5','7','8'];
		var days30=['04','06','09','11','4','6','9'];
		
		for(var i=0;i<days31.length;i++)
		{
			if(month == Number(days31[i]) )
			{
				return 31;
			}
		}
		
		for(i=0;i<days30.length;i++)
		{
			if(month == Number(days30[i]))
			{
				return 30;
			}
		}
		
		if(month == 2)
		{
			
			if(year%400==0||(year%4==0&&year%100!=0))
			{
				return 29;
			}
			else
			{
				return 28;
			}
		}
		throw new Error("the input is not valid");
	}
	
	
	//返回年份

	static returnYears(dateInput)
	{
		var length=dateInput.length;
		var year;
		var nowYear;
		var _date=FormItemDateResolver.dataStyle(new Date());
		switch(length)
		{
			case 5:
			{
				year=dateInput.substr(0,1);
				nowYear=_date.substr(0,3);
				nowYear=nowYear.concat(year);
				return parseInt(nowYear);
				break;
			}
			case 6:{
				year=dateInput.substr(0,2);
				nowYear=_date.substr(0,2);
				nowYear=nowYear.concat(year);
				return parseInt(nowYear);
				break;
			}
			case 7:{
				year=dateInput.substr(0,3);
				nowYear=_date.substr(0,1);
				nowYear=nowYear.concat(year);
				return parseInt(nowYear);
				break;
			}	
			case 8:{
				year=dateInput.substr(0,4);
				return parseInt(year);
				break;
			}	
			default:
			{
				break;
			}
		}
		return length;
	}
	
}





// WEBPACK FOOTER //
// ./src/formItem/resolver/FormItemDateResolver.js